import React, { Component, Fragment } from 'react';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardBody,
  CustomInput,
  NavItem,
  Nav,
  CardHeader,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  NavLink,
} from 'reactstrap';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { CardTitle } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import ticketStatus from '../../../../../data/ticketStatus';
import ticketTags from '../../../../../data/tags';
import {
  gAPI_Tickets_list,
  postAPI_Create_Ticket,
  gAPI_Tickets_By_Id,
  API_Web_RTC,
  putAPI_Update_Ticket,
  gAPI_Conversations_By_BotConversation,
  gAPI_TicketsRecording_id,
  postAPI_TrackEvent,
  gAPI_FormsTickets_By_Id,
  putAPI_Update_FormsTickets_Status,
  gAPI_Users_By_Id,
  gAPI_FormsCategoryList,
  gAPI_FormsBy_PropertyId,
  gAPI_ConversationSummaryByAssistant,
  gAPI_Internal_Property_By_Id,
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { CSVLink } from 'react-csv';
import {
  faFolder,
  faFilter,
  faUpload,
  faUserCheck,
  faArrowDown,
  faPlus,
  faLanguage,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import messenger_icon from '../../../../../assets/messenger_icon.png';
import ticket_no_conversation from '../../../../../assets/no_ticket_coversation.png';
import website_icon from '../../../../../assets/website_icon.png';
// import ticket_icon from '../../../../../assets/ticket_icon.png';
import google_icon from '../../../../../assets/google_icon.png';
import { getChat, getPropertyList } from '../../../../../redux/actions';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import TicketVisitor from '../../../../../containers/pages/ticketVisitor';
import 'moment-timezone';
import Validation from '../../../../../components/Validation';
// import { NavLink } from 'react-router-dom';
import {
  faFacebook,
  faFacebookMessenger,
} from '@fortawesome/free-brands-svg-icons';
import classnames from 'classnames';
import ArchivedTickets from '../../tickets/components/Archives';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import { localeOptions } from '../../../../../constants/defaultValues';
import WebRTC from '../Connections/WebRTC';
import KnowledgeSearch from './knowledgeSearch';
import ConnectOptions from './connectOptions';
import DialPad from './dialPad';
import { AvailabilityAndRates } from './availability';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Visitor from '../../../../../containers/pages/visitor';
import ConversationSummary from './conversationSummary';
import TicketsContactsForm from './TicketsContactsForm';
const quillModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
const StatusOptions = [
  { value: 'Open', label: 'Open' },
  { value: 'Pending', label: 'Assigned' },
  { value: 'Solved', label: 'Solved' },
  { value: 'Escalated', label: 'Escalated' },
  // { value: 'spam', label: 'Spam' },
  // { value: 'archived', label: 'Archived' },
];

const TicketType = [
  { value: 'GroupBooking', label: 'Group Booking Enquiries' },
  { value: 'Conference', label: 'Event Enquiries' },
  { value: 'LongStay', label: 'Long Stay Enquiries' },
  { value: 'FoodBeverage', label: 'Food & Beverage' },
];
const StatusOptionMissed = [
  { value: 'AssignBusiness', label: 'Assign to Business' },
  { value: 'AssignBookmebob', label: 'Assign to Myma.ai' },
];

let headers = [
  { label: 'Title', key: 'title' },
  { label: 'Status', key: 'status' },
  { label: 'Date', key: 'date' },
  { label: 'Messages/Notes', key: 'messageNotes' },
];
class TicketsPage extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.state = {
      startDate: moment().subtract(
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state !== null &&
          this.props.location.state.date != undefined
          ? this.props.location.state.date
          : 30,
        'days'
      ),
      endDate: moment().add(1, 'days'),
      hotel: {},
      embeddedDate: moment(),
      items: 20,
      tags: {},
      statuss: {},
      type:
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state !== null &&
          this.props.location.state.tagName != undefined
          ? this.props.location.state.tagName
          : undefined,
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      selectedChat: null,
      isLoading: false,
      showDialPad: false,
      detailsTab: 'Conversation',
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: false,
      ticketData: {},
      conversationData: [],
      preTicketStatus: null,
      popupProperty: null,
      ticketModalData: {},
      recordingurl: '',
      transcript: '',
      isOnCall: false,
      isMissingURL: '',
      tagValue: '',
      statusValue: '',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      selectedStatus: [],
      selectedTag: [],
      modelTicket: false,
      ticketType: null,
      ticketComments: '',
      missedResponseTitle: '',
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
      csvReport: {
        data: [],
        headers: headers,
        filename: 'missing-response.csv',
      },
      userName: '',
      userEmail: '',
      assignee: '',
      open: false,
      msg: [],
      categoryList: [],
      ticketCategory: [],
      statusFilter: [],
      categoryFilter: [],
      isNewTicket: false,
      ticketTitle: '',
      ticketSelectedStatus: [],
      ticketAssignTo: '',
      formList: [],
      ticketFormId: '',
      formWebviewUrl: '',
      csvTicket: [],
      isTranslate: false,
      translateLang: '',
      isExportCsv: false,
      propertyData: null,
    };
    window.addEventListener('message', this.windowMessage.bind(this), false);
  }

  windowMessage(event) {
    if (
      typeof event.data === 'string' &&
      event.data.startsWith('closeDashboardForm')
    ) {
      this.toggleNewTicket();
      this.handleSubmitClick();
      this.setState({
        ticketTitle: '',
        ticketComments: '',
        ticketSelectedCategory: [],
        ticketSelectedStatus: [],
        ticketAssignTo: '',
        ticketStatus: '',
      });
    }
  }
  LoadCSVTicketData(ticketList, startDate, endDate) {
    var csvticketlist = [
      { r1: 'Ticket Summary', r2: '', r3: '', r4: '', r5: '', r6: '', r7: '' },
      {},
      {
        r1: 'Start Date :' + startDate,
        r2: '',
        r3: '',
        r4: '',
        r5: '',
        r6: '',
        r7: '',
      },
      {
        r1: 'End Date :' + endDate,
        r2: '',
        r3: '',
        r4: '',
        r5: '',
        r6: '',
        r7: '',
      },
      {},
      {
        r1: 'Ticket Id',
        r2: 'Title',
        r3: 'Messages',
        r4: 'Logs',
        r5: 'Status',
        r6: 'Source',
        r7: 'Created Date',
      },
    ];
    ticketList.map((k) => {
      var notetext = '';
      if (k.notes.filter((l) => l.includes('<br>'))) {
        k.notes.map(
          (l) =>
            (notetext = l.replaceAll('<br>', ' | ').replaceAll('<br>', ' | '))
        );
      } else {
        k.notes.map((l) => (notetext = l));
      }
      // k.notes.map(n => {
      //   var notes = n.includes("<br>") ? n.split('<br>') : n.split('<br />');
      //   notes.map((item) => {
      //     notetext += item + "\n";
      //   });
      // })
      var statusText = '';
      k.statusNotes !== null &&
        k.statusNotes.map((note) => {
          statusText +=
            moment(note.createdDate).format('dddd, DD MMMM YYYY') +
            ' at ' +
            moment(note.createdDate).format('h:mm a') +
            ' \n' +
            note.text +
            '\n';
        });
      csvticketlist.push({
        r1: k.ticketId,
        r2: k.title,
        r3: notetext,
        r4: statusText,
        r5:
          StatusOptionMissed.filter((i) => i.value === k.status).length > 0
            ? StatusOptionMissed.filter((i) => i.value === k.status).map(
              (i) => i.label
            )
            : k.status,
        r6:
          k.source === 'OutlookPlugin'
            ? 'Outlook Addon'
            : k.source === 'BobDashboard'
              ? 'Dashboard'
              : k.source,
        r7:
          '' +
          moment(k.creationTime).format('dddd, DD MMMM YYYY') +
          ' at ' +
          moment(k.creationTime).format('h:mm a'),
      });
    });
    return csvticketlist;
  }
  componentDidMount() {
    this.handleWebRTC();
    var filterStatusList = [];
    StatusOptions.map((l) => filterStatusList.push({ ...l, checked: false }));
    this.setState({ statusFilter: filterStatusList });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      this.setState({ userName: res.data.fullName, userEmail: res.data.email });
    });
    const urll = window.location.pathname;
    const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true, isMissingURL: currentUrlName });
    var status = '-1';
    if (currentUrlName === 'missingresponse') {
      var selectedStatus = ticketStatus.filter((i) => i.value === 'Open');
      status = 'Open';
      this.setState({ selectedStatus: selectedStatus });
    }
    let { offset, items, startDate, endDate, type } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    this.props.getPropertyList();
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Tickets',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId
        }?group_id=${getGroupID()}`,
    }).then(async (res) => {
      console.log(res.data);
      this.setState({ propertyData: res.data });
    });

    var category = [];
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&lang=${this.props.locale}`,
    }).then((res) => {
      res.data.map((l) => category.push({ ...l, checked: false }));
    });
    var tag = '-1';
    if (this.props.categoryValue !== undefined) {
      tag = this.props.categoryValue;
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Tickets_list}?gid=${getGroupID()}&pid=${this.props.propertyId
        }&df=${start}&dt=${end}&tags=${tag}&offset=${offset}&limit=${items}&status=${status}&mr=${currentUrlName === 'missingresponse' ? 'yes' : 'no'
        }&type=${type === undefined || type === '' ? '-1' : type}`,
    }).then(
      (res) => {
        var tag = [];
        res.data.tickets.map((i) => {
          if (i.tags.length > 0) {
            i.tags.map((k) => tag.push({ label: k, value: k }));
          }
        });
        this.setState((state) => ({
          data: [...state.data, ...res.data.tickets],
          items: res.data.pageSize,
          offset: res.data.pageCount,
          isLoading: false,
          csvTicket: this.LoadCSVTicketData(res.data.tickets, start, end),
        }));

        var k = [...ticketTags, ...tag];
        var list = [...k, ...category];
        const unique = list.filter((obj, index) => {
          return index === list.findIndex((o) => obj.value === o.value);
        });
        var filtercate = [];
        unique.map((elem) => filtercate.push({ ...elem, checked: false }));
        if (this.props.categoryValue !== undefined) {
          filtercate = filtercate.map((k) => {
            if (k.value === this.props.categoryValue) {
              k.checked = true;
            }
            return k;
          });
          this.setState({
            selectedTag: filtercate
              .filter((x) => x.checked === true)
              .map((m) => m),
          });
        }
        this.setState({ categoryList: unique, categoryFilter: filtercate });

        let { data } = this.state;
        let ticketValue = [];
        var csvdata = { ...this.state.csvReport };
        if (data.length > 0) {
          data.map((elem) => {
            var status =
              StatusOptionMissed.filter((i) => i.value === elem.status).length >
                0
                ? StatusOptionMissed.filter((i) => i.value === elem.status).map(
                  (i) => i.label
                )[0]
                : elem.status;
            ticketValue.push({
              title: elem.requesterName,
              status: status,
              date: moment(elem.creationTime).format('DD/MM/YYYY hh:mm a'),
              messageNotes: elem.notes,
            });
          });
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.handleContactClick(
            0,
            data[0].id,
            data[0].conversationId,
            data[0].isTicket
          );
        }
        console.log(ticketValue);
        csvdata.data = ticketValue;
        console.log(csvdata);
        this.setState({ csvReport: csvdata });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=-1&df=${start}&dt=${end}&tags=-1&offset=${offset}&limit=${items}&country=-1&facebookSenderName=`,
    // }).then(
    //   res => {
    //     this.setState(state => ({
    //       conversationData: [...state.data, ...res.data.conversations],
    //       items: 200,
    //       offset: 200,
    //       isLoading: false,
    //     }));
    //     let { conversationData } = this.state;
    //     if (conversationData.length > 0) {
    //       this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
    //       this.props.getChat(conversationData[0].conversationId);
    //     }
    //   },
    //   error => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
  }

  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      this.setState({ selectedChat: props.chatListApp.selectedchat });
    }
  }

  handleContactClick = (index, userId, conversationId, isticket) => {
    this.setState({ activeIndex: index });
    this.setState({ isSummaryLoad: false });
    AxiosAPI({
      methhod: 'get',
      url: `${isticket === false ? gAPI_FormsTickets_By_Id : gAPI_Tickets_By_Id
        }/${userId}`,
    }).then((tres) => {
      if (conversationId !== '' && conversationId !== null) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_BotConversation}/${conversationId.replace(
            '|livechat',
            ''
          )}?gid=${getGroupID()}`,
        }).then((res) => {
          if (res.data.visitor && res.data.visitor.contactId) {
            console.log(
              'conversation.visitor.contactId',
              res.data.visitor.contactId
            );
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_TicketsRecording_id}?contactid=${res.data.visitor.contactId}`,
            }).then(
              (urlres) => {
                this.setState({
                  recordingurl: urlres.data.url,
                  selectedChat: res.data,
                  ticketData: tres.data,
                  transcript: urlres.data.transcript,
                });
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            this.setState({
              recordingurl: '',
              selectedChat: res.data,
              ticketData: tres.data,
              transcript: '',
            });
          }
        });
      } else {
        this.setState({
          ticketData: tres.data,
          selectedChat: undefined,
        });
      }
    });
  };
  // handleChangeDate = (date) => {
  //   this.setState({
  //     startDate: date,
  //   });
  // };

  // handleChangeEndDate = (date) => {
  //   this.setState({
  //     endDate: date,
  //   });
  // };
  // handleChangeDate = (date) => {
  //   this.setState(
  //     {
  //       startDate: date,
  //     },
  //     () => {
  //       const { startDate, endDate } = this.state;
  //       if (endDate && startDate > endDate) {
  //         this.setState({
  //           startDate: endDate,
  //           endDate: startDate,
  //         });
  //       }
  //     }
  //   );
  // };
  handleChangeDate = (date) => {
    this.setState({ startDate: date }, () => {
      const { startDate, endDate } = this.state;
      if (endDate && startDate > endDate) {
        this.setState({ endDate: startDate });

      }
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({ endDate: date }, () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate < startDate) {

        this.setState({ endDate: startDate });

      }
    });
  };

  handleGenerateSummary = async () => {
    this.setState({ isSummaryLoad: true });
    var conId = this.state.selectedChat.conversationId;
    await AxiosAPI({
      method: 'get',
      url: `${gAPI_ConversationSummaryByAssistant}/${conId}?group_id=${getGroupID()}`,
    }).then(async (res) => {
      if (res.data === 'success') {
        var count = 0;
        if (this.state.selectedChat.conversationSummary === null) {
          var intervalid = setInterval(() => {
            count++;
            if (count === 10) {
              clearInterval(intervalid);
              this.props.getChat(conId);
            }
          }, 500);
        } else {
          this.props.getChat(conId);
        }
      }
    });
  };
  // handleChangeEndDate = (date) => {
  //   this.setState(
  //     {
  //       endDate: date,
  //     },
  //     () => {
  //       const { startDate, endDate } = this.state;
  //       if (startDate && startDate > endDate) {
  //         // If endDate is before startDate,it will swap them
  //         this.setState({
  //           startDate: endDate,
  //           endDate: startDate,
  //         });
  //       }
  //     }
  //   );
  // };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChangeSelect = (value, { name }) => {
    if (name === 'statuss') {
      var m = this.state.statusFilter.map((elem) => {
        value.map((sel) => {
          if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
            elem.checked = true;
          }
        });
        return elem;
      });
      this.setState({
        selectedStatus: value,
        statusFilter: m,
      });
    } else if (name === 'tags') {
      var m = this.state.categoryFilter.map((elem) => {
        value.map((sel) => {
          if (sel.value.toLowerCase() === elem.value.toLowerCase()) {
            elem.checked = true;
          }
        });
        return elem;
      });
      this.setState({
        selectedTag: value,
        categoryFilter: m,
      });
    }
    this.setState({
      [name]: value,
    });
  };

  toggle = (item) => {
    if (item && item.id) {
      this.setState({ ticketModalData: item, selectedStatus: item.status });
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  toggleNewTicket = () => {
    var selectedProperty =
      this.props.usersListApp.properties !== undefined
        ? this.props.usersListApp.properties
          .filter((elem) => elem.id === this.props.propertyId)
          .map((pro) => {
            return { label: pro.name, value: pro.id };
          })[0]
        : null;
    this.setState((prevState) => ({
      isNewTicket: !prevState.isNewTicket,
      ticketStatus: 'Pending',
      ticketSelectedStatus: [{ label: 'Assigned', value: 'Pending' }],
      popupProperty: selectedProperty,
    }));
  };
  handleFormChange = (e) => {
    var formdata = this.state.formList.filter((l) => l.id === e.target.value);

    this.setState({
      ticketFormId: e.target.value,
      formWebviewUrl: `${process.env.REACT_APP_BASE_CHATUI +
        '/form-view?id=' +
        e.target.value +
        '&gid=' +
        formdata[0].groupId +
        '&pid=' +
        formdata[0].propertyId +
        '&dashboard=1'
        }`,
    });
  };

  handleChangeMultiCategory = (category) => {
    var cate = [];
    cate.push(category);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&lang=${this.props.locale}`,
    })
      .then((res) => {
        var formlist = res.data.filter((k) =>
          k.categories.includes(category.value)
        );
        var count = formlist.length;
        var url = '';
        if (count === 1) {
          url = `${process.env.REACT_APP_BASE_CHATUI +
            '/form-view?id=' +
            formlist[0].id +
            '&gid=' +
            formlist[0].groupId +
            '&pid=' +
            formlist[0].propertyId +
            '&dashboard=1'
            }`;
        }
        this.setState({
          ticketCategory: [category.value],
          ticketTitle: category.value,
          ticketSelectedCategory: cate,
          formList: formlist.length > 0 ? formlist : [],
          ticketFormId: count === 1 ? formlist[0].id : '',
          formWebviewUrl: url,
        });
      })
      .catch((err) => console.error(err));
  };
  handleStatus = (category) => {
    var cate = [];
    cate.push(category);
    this.setState({
      ticketStatus: category.value,
      ticketSelectedStatus: cate,
    });
  };
  // toggleTicket = () => {
  //   var selectedProperty = this.props.usersListApp.properties !== undefined ?
  //     this.props.usersListApp.properties.filter((elem) => elem.id === this.props.propertyId).map((pro) => {
  //       return { label: pro.name, value: pro.id }
  //     })[0] : null;

  //   this.setState((prevState) => ({ modelTicket: !prevState.modelTicket, popupProperty: selectedProperty }));
  // };

  handleSubmitClick = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
      isVisibleTicketBtn: false,
      data: [],
      selectedChat: null,
      activeIndex: -1,
      isFiltering: false,
      tagValue: '',
      statusValue: '',
    });
    let {
      items,
      hotel,
      startDate,
      endDate,
      statuss,
      tags,
      type,
      isMissingURL,
    } = this.state;
    startDate = startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : '';
    endDate = endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : '';
    const formattedTags =
      tags.length > 0
        ? tags.map((a) => a.value.replace(/\s*&\s*/g, '-')).join('|')
        : '-1';
    console.log('tag1', tags, formattedTags);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Tickets_list}?gid=${getGroupID()}&status=${statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1'
        }&tags=${formattedTags}&pid=${this.props.propertyId
        }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&mr=${isMissingURL === 'missingresponse' ? 'yes' : 'no'
        }&type=${type === undefined || type === '' ? '-1' : type}`,
    }).then(
      (res) => {
        this.setState({
          data: res.data.tickets,
          items: res.data.pageSize,
          offset: res.data.pageCount,
          isLoading: false,
          tagValue: tags.length > 0 ? tags.map((a) => a.value).join('|') : '-1',
          statusValue:
            statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1',
          csvTicket: this.LoadCSVTicketData(
            res.data.tickets,
            startDate,
            endDate
          ),
        });
        let { data } = this.state;
        let ticketValue = [];
        var csvdata = { ...this.state.csvReport };
        if (data.length > 0) {
          data.map((elem) => {
            var status =
              StatusOptionMissed.filter((i) => i.value === elem.status).length >
                0
                ? StatusOptionMissed.filter((i) => i.value === elem.status).map(
                  (i) => i.label
                )[0]
                : elem.status;
            ticketValue.push({
              title: elem.requesterName,
              status: status,
              date: moment(elem.creationTime).format('DD/MM/YYYY hh:mm a'),
              messageNotes: elem.notes,
            });
          });
          // this.props.getChat(data[0].conversationData);
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.handleContactClick(
            0,
            data[0].id,
            data[0].conversationId,
            data[0].isTicket
          );
        } else {
          this.setState({ ticketData: null });
        }
        var csvdata = { ...this.state.csvReport };
        csvdata.data = ticketValue;
        this.setState({ csvReport: csvdata });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&status=${
    //     statuss.length > 0 ? statuss.map(a => a.value).join('|') : '-1'
    //     }&tags=${
    //     tags.length > 0 ? tags.map(a => a.value).join('|') : '-1'
    //     }&pid=${
    //     hotel.length > 0 ? hotel.map(a => a.value).join('|') : '-1'
    //     }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=`,
    // }).then(
    //   res => {
    //     this.setState(state => ({
    //       conversationData: res.data.conversations,
    //       items: 200,
    //       offset: 200,
    //       isLoading: false,
    //     }));
    //     let { conversationData } = this.state;
    //     if (conversationData.length > 0) {
    //       this.props.getChat(conversationData[0].conversationId);
    //     }
    //   },
    //   error => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
  };

  handleCheckedFilter = (e) => {
    if (e.target.value !== '-1') {
      var m = this.state.categoryFilter.map((elem) => {
        if (e.target.value === elem.value) {
          elem.checked = !e.target.checked;
        }
        return elem;
      });
      this.setState({
        categoryFilter: m,
        tags: m.filter((x) => x.checked === true).map((m) => m),
        selectedTag: m.filter((x) => x.checked === true).map((m) => m),
      });
    } else {
      var list = [];
      this.state.categoryFilter.map((l) => list.push({ ...l, checked: false }));
      this.setState({ categoryFilter: list, tags: [], selectedTag: [] });
    }
    setTimeout(() => {
      this.handleSubmitClick();
    }, 500);
  };
  handleCheckedStatusFilter = (e) => {
    if (e.target.value !== '-1') {
      var m = this.state.statusFilter.map((elem) => {
        if (e.target.value === elem.value) {
          elem.checked = !e.target.checked;
        }
        return elem;
      });
      this.setState({
        statusFilter: m,
        statuss: m.filter((x) => x.checked === true).map((m) => m),
        selectedStatus: m.filter((x) => x.checked === true).map((m) => m),
      });
    } else {
      var list = [];
      this.state.statusFilter.map((l) => list.push({ ...l, checked: false }));
      this.setState({ statusFilter: list, statuss: [], selectedStatus: [] });
    }
    setTimeout(() => {
      this.handleSubmitClick();
    }, 500);
  };
  localize(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  handleTicketSubmit = () => {
    const { ticketNotes, preTicketStatus, ticketModalData } = this.state;
    var ticketStatus =
      ticketModalData.status === 'Pending'
        ? 'Assigned'
        : ticketModalData.status;
    var status =
      preTicketStatus !== null
        ? 'Status updated from ' +
        ticketStatus +
        ' to ' +
        preTicketStatus.label +
        ' by ' +
        this.state.userName +
        '<br>'
        : '';
    var assignStatus =
      this.state.assignee !== '' && preTicketStatus.label === 'Assigned'
        ? 'Assigned to ' + this.state.assignee + '<br>'
        : '';
    var note =
      ticketNotes !== ''
        ? 'Noted by ' + this.state.userName + ': <br> ' + ticketNotes
        : ticketNotes;

    const data = {
      statusNotes: status + assignStatus + note,
      status:
        (preTicketStatus && preTicketStatus.value) ||
        this.localize(ticketModalData.status),
      updator: this.state.userName,
      assignEmail: this.state.assignee,
    };

    AxiosAPI({
      method: 'put',
      url: `${ticketModalData.isTicket === false
        ? putAPI_Update_FormsTickets_Status
        : putAPI_Update_Ticket
        }/${ticketModalData.id}`,
      data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          this.setState({ msg: res.data.Messages });
          this.setState({ open: true });
        } else {
          this.setState({ ticketNotes: '', assignee: '' });
          this.toggle();
          var getIndex = this.state.data.findIndex(
            (obj) => obj.id === ticketModalData.id
          );
          this.handleContactClick(
            getIndex,
            ticketModalData.id,
            ticketModalData.conversationId,
            ticketModalData.isTicket
          );
          this.setState({ ticketModalData: null });
          this.handleSubmitClick();
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  handleLoadMore = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
    });
    const urll = window.location.pathname;
    const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);

    let {
      offset,
      items,
      startDate,
      endDate,
      isMissingURL,
      statuss,
      tags,
      type,
    } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    const formattedTags =
      tags.length > 0
        ? tags.map((a) => a.value.replace(/\s*&\s*/g, '-')).join('|')
        : '-1';
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Tickets_list}?gid=${getGroupID()}&pid=${this.props.propertyId
        }&df=${start}&dt=${end}&tags=${formattedTags}&offset=${offset}&limit=${items}&status=${statuss.length > 0 ? statuss.map((a) => a.value).join('|') : '-1'
        }&mr=${currentUrlName === 'missingresponse' ? 'yes' : 'no'}&type=${type === undefined || type === '' ? '-1' : type
        }`,
    }).then(
      (res) => {
        // setTickets(res.data.tickets);
        // setLoading(false);
        this.setState((state) => ({
          data: [...state.data, ...res.data.tickets],
          items: res.data.pageSize,
          offset: res.data.pageCount,
          isLoading: false,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };
  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };

  handleNotes = (source, e) => {
    if (source === 'user') this.setState({ ticketNotes: e });
  };

  handleCreateTicketSubmit = () => {
    const {
      ticketComments,
      missedResponseTitle,
      ticketStatus,
      ticketTitle,
      ticketCategory,
      ticketAssignTo,
      ticketType,
      popupProperty,
      selectedChat,
    } = this.state;
    let tickets = ['Missing Bot Response'];
    // ticketType && ticketType.map((ticket) => tickets.push(ticket.value));
    var statusNotes = [];
    if (ticketStatus === 'Pending') {
      statusNotes.push({
        assignEmail: ticketAssignTo,
        text: 'Assigned to ' + ticketAssignTo,
        createdBy: this.state.userEmail,
      });
    }
    statusNotes.push({
      assignEmail: '',
      text: 'Ticket created by ' + this.state.userEmail,
      createdBy: this.state.userEmail,
    });
    const data = {
      notes: ticketComments,
      title: ticketTitle,
      tags: ticketCategory === '' ? [] : ticketCategory,
      creator: 'Dashboard',
      Source: 'BobDashboard',
      //conversationId: selectedChat.botConversationId,
      conversationId: null,
      propertyId: popupProperty && popupProperty.value,
      groupId: getGroupID(),
      type: ticketType,
      assignTo: ticketAssignTo,
      status: ticketStatus,
      statusNotes: statusNotes,
    };
    if (missedResponseTitle !== null && missedResponseTitle !== '') {
      data.requesterName = missedResponseTitle;
    }
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Ticket}/dashboard`,
      data,
    })
      .then(() => {
        ///this.toggleTicket();
        this.toggleNewTicket();
        this.handleSubmitClick();
        this.setState({
          ticketTitle: '',
          ticketComments: '',
          ticketSelectedCategory: [],
          ticketSelectedStatus: [],
          ticketAssignTo: '',
          ticketStatus: '',
        });
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  handleWebRTC = () => {
    if (
      this.props.integrations !== undefined &&
      this.props.integrations.filter(
        (f) =>
          f.channel === 'WebRTC' &&
          f.properties.includes(this.props.propertyId) &&
          f.disabled === false
      ).length > 0
    ) {
      AxiosAPI({
        method: 'get',
        url: `${API_Web_RTC}/${this.props.integrations.filter(
          (f) =>
            f.channel === 'WebRTC' &&
            f.properties.includes(this.props.propertyId) &&
            f.disabled === false
        )[0].id
          }?group_id=${getGroupID()}`,
      }).then((res) => {
        if (res.data.webRTCIntegration !== undefined) {
          this.setState({ webRTCIntegration: res.data.webRTCIntegration });
        }
      });
    }
  };

  getImage = (phoneNumber, source) => {
    //image link according to service provider
    const assets_Url =
      this.props.featuresUrl && !this.props.featuresUrl.includes('myma.ai')
        ? `https://assets.${this.props.featuresUrl}`
        : 'https://assets.bookmebob.com';

    if (source === 'Phone') {
      if (phoneNumber !== '' && phoneNumber !== undefined) {
        if (
          phoneNumber.startsWith('+6422') ||
          phoneNumber.startsWith('+6427') ||
          phoneNumber.startsWith('+6421') ||
          phoneNumber.startsWith('+6428') ||
          phoneNumber.startsWith('+6429')
        ) {
          return (
            <img
              // src="https://assets.bookmebob.com/images/mobile.png"
              src={`${assets_Url}/images/mobile.png`}
              alt="mobile"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        } else {
          return (
            <img
              // src="https://assets.bookmebob.com/images/landline.png"
              src={`${assets_Url}/images/landline.png`}
              alt="landline"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        }
      } else {
        return (
          <img
            // src="https://assets.bookmebob.com/images/chat.png"
            src={`${assets_Url}/images/chat.png`}
            alt="chat"
            className="img-thumbnail border-0 mt-2 ml-2"
            style={{ maxWidth: '35px' }}
          />
        );
      }
    } else if (source === 'PhoneSuite') {
      return <i className="simple-icon-call-in" style={{ fontSize: '25px' }} />;
    } else if (source === 'WebsiteDirectLine') {
      return <i className="simple-icon-globe" style={{ fontSize: '25px' }} />;
    } else if (source === 'EmailDirectLine') {
      return <i className="iconsminds-envelope" style={{ fontSize: '25px' }} />;
    } else if (source === 'GoogleBusinessMessage') {
      return (
        <img
          src={google_icon}
          alt="google"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'WhatsApp') {
      return (
        <img
          // src="https://assets.bookmebob.com/images/whatsapp_icon.png"
          src={`${assets_Url}/images/whatsapp_icon.png`}
          alt="whatsapp"
          className="img-thumbnail border-0 mt-2 ml-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'FacebookDirectLine') {
      return (
        <img
          src={messenger_icon}
          alt="facebook"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else {
      return (
        <i className="iconsminds-mail-inbox" style={{ fontSize: '30px' }} />
      );
    }
  };

  isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  getVisitorNameDetail = () => {
    if (this.state.ticketData !== undefined) {
      let visitor = this.state.ticketData;
      if (visitor !== undefined) {
        if (
          visitor?.requesterName &&
          visitor.requesterName !== null &&
          visitor.requesterName !== ''
        )
          return (
            <Fragment>
              <span
                className="ml-1"
                style={{
                  width: '23%',
                  textTransform: 'capitalize',
                  color: 'black',
                }}
              >
                {visitor.requesterName}
              </span>
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '15px', color: 'black' }}
              >
                {visitor.status === 'Pending' ? 'Assigned' : visitor.status}
              </p>
            </Fragment>
          );
        else if (
          visitor?.requesterEmail &&
          visitor.requesterEmail !== null &&
          visitor.requesterEmail !== ''
        )
          return (
            <Fragment>
              <span
                className="ml-1"
                style={{ width: '23%', textTransform: 'capitalize' }}
              >
                {visitor.requesterEmail}
              </span>{' '}
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '15px' }}
              >
                {visitor.status === 'Pending' ? 'Assigned' : visitor.status}
              </p>
            </Fragment>
          );
        else if (
          visitor?.rquesterPhoneNumber &&
          visitor.rquesterPhoneNumber !== null &&
          visitor.rquesterPhoneNumber !== ''
        )
          return (
            <Fragment>
              <span
                className="ml-1"
                style={{ width: '23%', textTransform: 'capitalize' }}
              >
                {visitor.rquesterPhoneNumber}
              </span>
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '15px' }}
              >
                {visitor.status === 'Pending' ? 'Assigned' : visitor.status}
              </p>
            </Fragment>
          );
        else
          return (
            <Fragment>
              <span className="ml-1 mt-2" style={{ width: '23%' }}>
                {visitor.status === 'Pending' ? 'Assigned' : visitor.status}
              </span>
            </Fragment>
          );
      }
    }
    return <span className="ml-1" style={{ width: '23%' }}></span>;
  };

  handleUpdateStatus = (item, status) => {
    if (item && item.id) {
      this.setState({
        ticketModalData: item,
        selectedStatus: status,
        preTicketStatus: {
          label: status === 'Pending' ? 'Assigned' : status,
          value: status,
        },
      });
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  handleNewCall = () => {
    this.setState({ showNewOptions: false });
    this.setState({ showDialPad: true });
  };

  handleNewTicket = () => {
    this.setState({ showNewOptions: false });
    this.toggleNewTicket();
  };

  handleRTCNumber = (val) => {
    this.setState({ isOnCall: true });
    this.setState({ rtcNumber: val });
  };
  handleChangeLocale = (locale, direction) => {
    this.setState({ translateLang: locale, isTranslate: true });
  };

  render() {
    const {
      usersListApp: { properties },
    } = this.props;

    const {
      selectedChat,
      startDate,

      endDate,
      ticketData,
      modal,
      preTicketStatus,
      ticketModalData,
      selectedStatus,
      selectedTag,
      modelTicket,
      ticketType,
      popupProperty,
      webRTCIntegration,
      rtcNumber,
      detailsTab,
      showDialPad,
      isNewTicket,
    } = this.state;
    const statusList =
      ticketModalData &&
      ticketModalData.status &&
      [...StatusOptions, ...StatusOptionMissed].filter(
        (i) => i.value === ticketModalData.status
      );

    const preFillStatus = ticketModalData &&
      ticketModalData.status && {
      value:
        statusList.length > 0
          ? statusList.map((i) => i.value)[0]
          : ticketModalData.status,
      label:
        statusList.length > 0
          ? statusList.map((i) => i.label)[0]
          : ticketModalData.status,
    };
    return (
      <Fragment>
        <div>
          <Row>
            <Colxx xxs="11" style={{ flex: '0 0 89%' }}>
              <Row>
                <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pr-0">
                  <CardHeader className="pl-0 pr-0">
                    <Nav
                      tabs
                      className="card-header-tabs ml-0 mr-0"
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid lightgray',
                      }}
                    >
                      <NavItem className="text-center nav-width">
                        <NavLink
                          style={{
                            background: `${this.props.activeTab === 'Active'
                              ? 'white'
                              : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: this.props.activeTab === 'Active',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.props.handleSelectedTab('Active');
                          }}
                          to="#"
                          title="Active Conversations"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLineJoin="round"
                                d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                              />
                            </svg>
                          </i>
                        </NavLink>
                      </NavItem>
                      <NavItem className="text-center nav-width">
                        <NavLink
                          style={{
                            background: `${this.props.activeTab === 'AllConversations'
                              ? 'white'
                              : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: this.props.activeTab === 'AllConversations',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.props.handleSelectedTab('AllConversations');
                          }}
                          to="#"
                          title="All Conversations"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLineJoin="round"
                                d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                              />
                            </svg>
                          </i>
                        </NavLink>
                      </NavItem>
                      <NavItem className="text-center nav-width">
                        <NavLink
                          style={{
                            background: `${this.props.activeTab === 'Tickets'
                              ? 'white'
                              : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: this.props.activeTab === 'Tickets',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.props.handleSelectedTab('Tickets');
                          }}
                          to="#"
                          title="Tickets"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLineJoin="round"
                                d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                              />
                            </svg>
                          </i>
                          {this.props.activeTab === 'Tickets' && (
                            <IntlMessages id="dashboards.tickets" />
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem
                        className="text-center float-right"
                        style={{ background: '' }}
                      >
                        {this.state.isFiltering && (
                          <Row>
                            <Fragment>
                              <Card
                                style={{
                                  position: 'absolute',
                                  zIndex: '1',
                                  top: '2.5rem',
                                  right: '1rem',
                                  marginLeft: '-1rem',
                                  boxShadow:
                                    '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                                }}
                              >
                                <CardBody>
                                  <Colxx xxs="12" md="12" className="mb-2">
                                    <DatePicker
                                      style={{ borderRadius: '10px' }}
                                      selected={
                                        startDate ? new Date(startDate) : null
                                      } // ensure Date object
                                      onChange={this.handleChangeDate}
                                      placeholderText="Start Date"
                                      dateFormat="dd/MM/yyyy" // ✅ correct format
                                    />
                                  </Colxx>
                                  <Colxx xxs="12" md="12" className="mb-2">
                                    <DatePicker
                                      style={{ borderRadius: '10px' }}
                                      selected={
                                        endDate ? new Date(endDate) : null
                                      } // ✅ always Date object
                                      onChange={this.handleChangeEndDate}
                                      placeholderText="End Date"
                                      dateFormat="dd/MM/yyyy" // ✅ correct format
                                    />
                                  </Colxx>
                                  <Colxx xxs="12" md="12" className="mb-2">
                                    <Select
                                      isMulti={true}
                                      // components={{ Input: CustomSelectInput }}
                                      className="react-select"
                                      classNamePrefix="react-select"
                                      name="statuss"
                                      placeholder="Select Status"
                                      onChange={this.handleChangeSelect}
                                      options={
                                        this.state.isMissingURL !==
                                          'missingresponse'
                                          ? ticketStatus
                                          : [
                                            ...ticketStatus,
                                            ...StatusOptionMissed,
                                          ]
                                      }
                                      value={selectedStatus}
                                    />
                                  </Colxx>
                                  <Colxx
                                    xxs="12"
                                    md="12"
                                    className="mb-2"
                                    style={{
                                      display:
                                        this.state.isMissingURL !==
                                          'missingresponse'
                                          ? 'block'
                                          : 'none',
                                    }}
                                  >
                                    <Select
                                      isMulti={true}
                                      // components={{ Input: CustomSelectInput }}
                                      className="react-select"
                                      classNamePrefix="react-select"
                                      name="tags"
                                      placeholder="Select Categories"
                                      onChange={this.handleChangeSelect}
                                      options={this.state.categoryList}
                                      value={selectedTag}
                                    />
                                  </Colxx>
                                  {/* {this.state.isMissingURL !==
                                    'missingresponse' && (
                                    <Colxx xxs="12" md="12" className="mb-2">
                                      <Input
                                        type="select"
                                        value={this.state.type}
                                        name="type"
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="-1">All Types</option>
                                        {TicketType.map((item, i) => (
                                          <option value={item.value} key={i}>
                                            {item.label}
                                          </option>
                                        ))}
                                      </Input>
                                    </Colxx>
                                  )} */}
                                  <Colxx xxs="12" md="12" className="mt-3">
                                    <Button
                                      size="xs"
                                      color="primary"
                                      className="mb-2 mr-2"
                                      onClick={() => this.handleSubmitClick()}
                                    >
                                      <IntlMessages id="forms.submit" />
                                    </Button>
                                    <Button
                                      size="xs"
                                      color="secondary"
                                      className="mb-2 mr-2 ml-2"
                                      onClick={() =>
                                        this.setState({ isFiltering: false })
                                      }
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      size="xs"
                                      color="dark"
                                      className="mb-2"
                                      onClick={() =>
                                        this.setState({ isExportCsv: true })
                                      }
                                    >
                                      Export CSV
                                    </Button>
                                    {/* {this.state.isMissingURL ===
                                      'missingresponse' ? (
                                      <Fragment>
                                        {this.state.csvReport.data.length >
                                          0 ? (
                                          <Button
                                            size="xs"
                                            color="dark"
                                            className="mb-2"
                                          >
                                            <CSVLink {...this.state.csvReport}>
                                              <span style={{ color: 'white' }}>
                                                Download CSV
                                              </span>
                                            </CSVLink>
                                          </Button>
                                        ) : (
                                          <Button
                                            size="xs"
                                            color="dark"
                                            className="mb-2"
                                          >
                                            <span style={{ color: 'white' }}>
                                              Download CSV
                                            </span>
                                          </Button>
                                        )}
                                      </Fragment>
                                    ) :
                                      <Fragment>
                                        {this.state.csvTicket.length >
                                          0 ? (
                                          <Button
                                            size="xs"
                                            color="dark"
                                            className="mb-2"
                                          >
                                            <CSVLink data={this.state.csvTicket} headers={[
                                              { key: "r1", label: "" },
                                              { key: "r2", label: "" },
                                              { key: "r3", label: "" },
                                              { key: "r4", label: "" },
                                              { key: "r5", label: "" },
                                              { key: "r6", label: "" },
                                              { key: "r7", label: "" },
                                            ]} filename="ticket-summary.csv">
                                              <span style={{ color: 'white' }}>
                                                Download CSV
                                              </span>
                                            </CSVLink>
                                          </Button>
                                        ) : (
                                          <Button
                                            size="xs"
                                            color="dark"
                                            className="mb-2"
                                          >
                                            <span style={{ color: 'white' }}>
                                              Download CSV
                                            </span>
                                          </Button>
                                        )}
                                      </Fragment>
                                    } */}
                                  </Colxx>
                                </CardBody>
                              </Card>
                            </Fragment>
                          </Row>
                        )}
                        <Button
                          size="xs"
                          outline
                          color="primary"
                          style={{ marginTop: '12px' }}
                          className="ml-2  btn-round"
                          onClick={() =>
                            this.setState({
                              isFiltering: !this.state.isFiltering,
                            })
                          }
                          title="Filter"
                        >
                          <FontAwesomeIcon
                            icon={faFilter}
                            className="fa mr-1"
                          />
                        </Button>
                        {this.state.showNewOptions !== undefined &&
                          this.state.showNewOptions === true ? (
                          <Button
                            size="xs"
                            outline
                            color="primary"
                            style={{ marginTop: '12px' }}
                            onClick={() =>
                              this.setState({ showNewOptions: false })
                            }
                            className=" ml-2 btn-round"
                          >
                            <FontAwesomeIcon
                              icon={faArrowDown}
                              className="fa mr-1"
                            />
                          </Button>
                        ) : (
                          <Button
                            size="xs"
                            outline
                            color="primary"
                            style={{ marginTop: '12px' }}
                            onClick={() =>
                              this.setState({ showNewOptions: true })
                            }
                            className=" ml-2 btn-round"
                            title="Create Ticket"
                          >
                            <FontAwesomeIcon
                              icon={faPlus}
                              className="fa mr-1"
                            />
                          </Button>
                        )}
                        {webRTCIntegration !== undefined && (
                          <Button
                            size="xs"
                            outline
                            color="primary"
                            className=" ml-2 btn-round"
                            style={{ marginTop: '12px' }}
                            onClick={this.handleNewCall}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              className="fa mr-1"
                              viewBox="0 0 24 24"
                              style={{ fill: 'white' }}
                            >
                              <circle cx="12" cy="6" r="2"></circle>
                              <circle cx="6" cy="6" r="2"></circle>
                              <circle cx="18" cy="6" r="2"></circle>
                              <circle cx="12" cy="12" r="2"></circle>
                              <circle cx="6" cy="12" r="2"></circle>
                              <circle cx="18" cy="12" r="2"></circle>
                              <circle cx="12" cy="18" r="2"></circle>
                            </svg>
                          </Button>
                        )}
                        {this.state.showNewOptions !== undefined &&
                          this.state.showNewOptions === true && (
                            <Row>
                              <Fragment>
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '50px',
                                    zIndex: '9999',
                                    right: '40px',
                                  }}
                                >
                                  <Colxx xxs="12" md="12" className="mt-1">
                                    <Button
                                      color="primary"
                                      className="mb-2 btn-round btn-call mr-2"
                                      outline
                                      onClick={this.handleNewCall}
                                    >
                                      + Call
                                    </Button>
                                  </Colxx>
                                  <Colxx xxs="12" md="12" className="mt-1">
                                    <Button
                                      color="primary"
                                      outline
                                      className="mb-2 btn-round btn-call mr-2"
                                      onClick={this.handleNewTicket}
                                    >
                                      + Ticket
                                    </Button>
                                  </Colxx>
                                </div>
                              </Fragment>
                            </Row>
                          )}
                      </NavItem>
                    </Nav>
                  </CardHeader>
                  <Card>
                    <div
                      className="card-body mt-0 ticketArchive"
                      style={{ padding: '15px 2px 0px 10px !important' }}
                    >
                      <ArchivedTickets
                        getImage={this.getImage}
                        isAgentAssist={true}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        offset={this.state.offset}
                        items={this.state.items}
                        isLoading={this.state.isLoading}
                        data={
                          Array.isArray(this.state.data) ? this.state.data : []
                        }
                        activeIndex={this.state.activeIndex}
                        handleContactClick={this.handleContactClick}
                        propertyId={this.props.propertyId}
                        isMissingUrl={
                          this.state.isMissingURL === 'missingresponse'
                            ? true
                            : false
                        }
                        tagValue={this.state.tagValue}
                        statusValue={this.state.statusValue}
                        handleLoadMore={this.handleLoadMore}
                        handleMaskClick={this.handleMaskClick}
                        isMasked={this.state.isMasked}
                        categoryList={this.state.categoryList}
                      />
                    </div>
                  </Card>
                  {showDialPad && (
                    <DialPad
                      isvisible={showDialPad}
                      //isOnCall={isOnCall}
                      toggle={() => this.setState({ showDialPad: false })}
                      handlePhoneNumber={(val) => this.handleRTCNumber(val)}
                    ></DialPad>
                  )}
                </Colxx>

                <Colxx
                  xxs="12"
                  md="4"
                  className="mb-2 col-sm-12 col-md-4 pl-1 pr-1"
                >
                  {ticketData && ticketData.id && (
                    <CardHeader className="pl-0 pr-0">
                      <Nav
                        tabs
                        className="card-header-tabs ml-0 mr-0"
                        style={{
                          backgroundColor: 'white',
                          border: '1px solid lightgray',
                          height: '50.5px',
                        }}
                      >
                        <NavItem
                          className="text-center"
                          style={{ width: '100%', background: '' }}
                        >
                          {this.state.isOnCall === false && (
                            <Row className="px-0">
                              <Colxx md={12} className="text-left">
                                <div className="d-flex">
                                  {this.getVisitorNameDetail()}
                                  <span
                                    className="text-right d-flex"
                                    style={{ width: '77%' }}
                                  >
                                    {/* {(selectedChat !== undefined && selectedChat !== null &&
                                                                            selectedChat.channel !== undefined && selectedChat.channel !== 'PhoneSuite') ?
                                                                            <Fragment>
                                                                                <Button size="xs" outline color="primary" className="ml-1 btn-round"
                                                                                    onClick={() => this.setState({ isOnCall: !this.state.isOnCall })}
                                                                                >
                                                                                    Call
                                                                                </Button>
                                                                            </Fragment>
                                                                            : null} */}

                                    {/* <Button size="xs" outline color="primary" className="ml-1 btn-round">
                                                                                {(selectedChat !== null && selectedChat.channel === 'PhoneSuite') ?
                                                                                    <Fragment>
                                                                                        <FontAwesomeIcon icon={faSms}></FontAwesomeIcon> SMS
                                                                                    </Fragment> :
                                                                                    <Fragment>
                                                                                        <FontAwesomeIcon icon={faReply}></FontAwesomeIcon> Reply
                                                                                    </Fragment>}
                                                                            </Button> */}
                                    {/* {(selectedChat.channel !== undefined && selectedChat !== null && webRTCIntegration !== undefined) &&
                                                                                } */}

                                    {/* <Button size="xs" outline color="primary" onClick={this.toggle} className="ml-1 btn-round">
                                                                            <FontAwesomeIcon icon={faTicketAlt}></FontAwesomeIcon> Ticket
                                                                        </Button> */}

                                    {/* {selectedChat &&
                                                                                <Fragment>
                                                                                    {selectedChat.status === 'Open' ?
                                                                                        <Button size="xs" outline color="primary" onClick={() => this.handleStatusSubmit('solved')} className="mx-1 btn-round">
                                                                                             Close
                                                                                        </Button> :
                                                                                        <Button size="xs" outline color="primary" onClick={() => this.handleStatusSubmit('Open')} className="mx-1 btn-round">
                                                                                             Open
                                                                                        </Button>}
                                                                                </Fragment>} */}
                                    <Button
                                      size="xs"
                                      outline
                                      color="primary"
                                      onClick={() =>
                                        this.handleUpdateStatus(
                                          ticketData,
                                          ticketData.status
                                        )
                                      }
                                      style={{ marginTop: '12px' }}
                                      className="btn-round mr-1"
                                    >
                                      + <IntlMessages id="content.notes" />
                                    </Button>
                                    {ticketData.status === 'Pending' && (
                                      <Fragment>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Pending'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUserCheck}
                                          ></FontAwesomeIcon>{' '}
                                          <IntlMessages id="content.reassign" />
                                        </Button>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Open'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                          ></FontAwesomeIcon>{' '}
                                          <IntlMessages id="content.open" />
                                        </Button>
                                      </Fragment>
                                    )}
                                    {ticketData.status === 'Solved' && (
                                      <Fragment>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Open'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUpload}
                                          ></FontAwesomeIcon>{' '}
                                          <IntlMessages id="content.open" />
                                        </Button>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Pending'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUserCheck}
                                          ></FontAwesomeIcon>{' '}
                                          Assign
                                        </Button>
                                      </Fragment>
                                    )}
                                    {ticketData.status === 'Open' && (
                                      <Fragment>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Solved'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowDown}
                                          ></FontAwesomeIcon>{' '}
                                          <IntlMessages id="content.close" />
                                        </Button>
                                        <Button
                                          size="xs"
                                          outline
                                          color="primary"
                                          onClick={() =>
                                            this.handleUpdateStatus(
                                              ticketData,
                                              'Pending'
                                            )
                                          }
                                          style={{ marginTop: '12px' }}
                                          className="mr-1 btn-round"
                                        >
                                          <FontAwesomeIcon
                                            icon={faUserCheck}
                                          ></FontAwesomeIcon>{' '}
                                          Assign
                                        </Button>
                                      </Fragment>
                                    )}
                                    <Fragment>
                                      <UncontrolledDropdown
                                        className="dropdown-menu-right"
                                        style={{ marginTop: '12px' }}
                                      >
                                        <DropdownToggle
                                          size="xs"
                                          outline
                                          color="primary"
                                          className="btn-round mr-1"
                                          title="Language"
                                        >
                                          {this.state.translateLang === '' ? (
                                            <span>
                                              <FontAwesomeIcon
                                                icon={faLanguage}
                                                className="fa"
                                                style={{ fontSize: '20px' }}
                                              />
                                              {/* <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                                width="25px" height="25px" viewBox="0 0 220.000000 229.000000"
                                                preserveAspectRatio="xMidYMid meet">

                                                <g transform="translate(0.000000,229.000000) scale(0.100000,-0.100000)" stroke="none">
                                                  <path d="M1839 2220 c-24 -32 -47 -59 -52 -60 -4 0 -24 11 -45 23 -187 118 -426 93 -591 -61 -35 -33 -48 -51 -36 -48 148 35 297 -9 416 -123 l60 -56 -47 -58 c-25 -32 -44 -60 -41 -63 6 -6 423 47 436 56 8 5 -42 436 -51 445 -2 3 -24 -22 -49 -55z" />
                                                  <path d="M159 1868 c-69 -36 -120 -99 -139 -169 -7 -26 -10 -154 -8 -357 3 -303 4 -319 25 -357 40 -75 120 -134 218 -160 7 -2 8 -36 2 -105 -6 -73 -5 -110 3 -130 13 -32 59 -55 93 -46 13 3 103 69 201 146 l178 140 113 0 112 0 6 -38 c11 -63 58 -126 118 -156 52 -26 56 -26 264 -26 l212 0 153 -115 c149 -112 185 -130 208 -102 6 7 14 57 19 112 l8 100 46 6 c82 12 146 59 180 134 17 36 19 70 19 333 0 323 -2 337 -63 401 -66 69 -74 71 -438 71 l-326 0 -6 73 c-3 39 -13 89 -21 110 -24 55 -84 117 -141 143 l-50 24 -462 0 -461 0 -63 -32z m996 -67 c47 -22 89 -64 104 -104 15 -38 15 -626 0 -664 -15 -40 -57 -82 -104 -104 -35 -16 -67 -19 -248 -19 l-208 0 -175 -138 c-96 -75 -180 -139 -186 -141 -6 -2 -8 5 -5 15 3 11 9 74 13 140 l6 122 -66 4 c-79 5 -137 40 -170 103 -20 37 -21 59 -24 330 -2 207 0 303 9 334 15 53 74 116 121 130 18 5 224 9 463 10 398 1 433 -1 470 -18z m541 -446 c12 -12 55 -114 97 -226 41 -112 78 -212 82 -221 6 -16 0 -18 -64 -18 l-71 0 -11 45 -11 45 -77 0 -77 0 -12 -45 -12 -45 -69 0 -68 0 77 208 c42 114 85 222 94 240 29 56 81 63 122 17z" />
                                                  <path d="M620 1655 c0 -25 0 -25 -95 -25 l-95 0 0 -50 0 -50 83 -1 c45 -1 73 -4 62 -6 -11 -3 -30 -9 -43 -14 l-22 -9 25 -67 c14 -38 39 -89 55 -115 l29 -48 -57 -47 c-31 -27 -70 -57 -86 -69 l-28 -21 23 -36 c13 -20 27 -37 30 -37 3 0 44 31 92 70 77 62 88 67 96 51 10 -18 124 -114 172 -145 27 -17 27 -17 50 20 l23 37 -34 26 c-57 43 -123 102 -141 125 -17 22 -16 24 27 87 25 36 54 93 65 131 16 53 25 68 40 68 16 0 19 8 19 50 l0 50 -95 0 c-95 0 -95 0 -95 25 0 23 -3 25 -50 25 -47 0 -50 -2 -50 -25z m140 -176 c-21 -57 -65 -129 -79 -129 -8 0 -60 110 -75 158 -7 22 -6 22 83 22 l91 0 -20 -51z" />
                                                  <path d="M1613 1150 l-20 -70 49 0 c36 0 49 4 45 13 -2 6 -13 38 -23 70 -10 31 -20 57 -24 57 -3 0 -15 -31 -27 -70z" />
                                                  <path d="M667 515 c-115 -35 -211 -66 -214 -68 -4 -5 114 -426 122 -435 2 -2 21 28 42 67 28 52 42 69 53 64 112 -48 240 -64 331 -43 30 7 79 25 111 41 62 31 163 120 191 168 l18 30 -43 -15 c-136 -48 -313 -13 -428 85 l-35 30 38 70 c20 39 34 71 30 70 -5 0 -102 -29 -216 -64z" />
                                                </g>
                                              </svg> */}
                                            </span>
                                          ) : (
                                            <span className="name">
                                              {this.state.translateLang.toUpperCase()}
                                            </span>
                                          )}
                                        </DropdownToggle>
                                        <DropdownMenu
                                          right
                                          style={{ marginTop: '15px' }}
                                        >
                                          {localeOptions.map((elem, index) => {
                                            return (
                                              <DropdownItem
                                                onClick={() =>
                                                  this.handleChangeLocale(
                                                    elem.id,
                                                    elem.direction
                                                  )
                                                }
                                                key={index}
                                              >
                                                {elem?.name}
                                              </DropdownItem>
                                            );
                                          })}
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </Fragment>
                                  </span>
                                </div>
                              </Colxx>
                            </Row>
                          )}
                          <Fragment>
                            {/* {webRTCIntegration !== undefined ? (
                              <WebRTC
                                isOncall={this.state.isOnCall}
                                rtcNumber={rtcNumber}
                                number={
                                  ticketData?.requesterPhoneNumber
                                    ? ticketData?.requesterPhoneNumber
                                    : ''
                                }
                                handleBackToChat={() =>
                                  this.setState({
                                    isOnCall: !this.state.isOnCall,
                                  })
                                }
                                webRTCIntegration={webRTCIntegration}
                              ></WebRTC>
                            ) : null} */}
                          </Fragment>
                        </NavItem>
                      </Nav>
                    </CardHeader>
                  )}

                  {ticketData && ticketData.id && (
                    <TicketVisitor
                      item={ticketData}
                      hideButton={true}
                      handleStatusClicked={(item) => this.toggle(item)}
                      conversation={selectedChat}
                      recordingurl={this.state.recordingurl}
                      transcript={this.state.transcript}
                      handleMaskClick={this.handleMaskClick}
                      isMasked={this.state.isMasked}
                      //toggleTicket={this.toggleTicket}
                      isMissingUrl={
                        this.state.isMissingURL === 'missingresponse'
                          ? true
                          : false
                      }
                      translateLang={this.state.translateLang}
                      isTranslate={this.state.isTranslate}
                    />
                  )}
                </Colxx>

                <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pl-0">
                  {/* <CardTitle>Chat</CardTitle>{' '} */}
                  <CardHeader className="pl-0 pr-0">
                    <Nav
                      tabs
                      className="card-header-tabs ml-0 mr-0"
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid lightgray',
                      }}
                    >
                      <NavItem className="text-center">
                        <NavLink
                          style={{
                            background: `${detailsTab === 'Conversation' ? 'white' : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: detailsTab === 'Conversation',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.setState({ detailsTab: 'Conversation' });
                            this.setState({ isSummaryLoad: false });
                          }}
                          to="#"
                          title="Conversation"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                              />
                            </svg>
                          </i>
                          {detailsTab === 'Conversation' && (
                            <IntlMessages id="content.conversation" />
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem className="text-center">
                        <NavLink
                          style={{
                            background: `${detailsTab === 'KnowledgeSearch'
                              ? 'white'
                              : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: detailsTab === 'KnowledgeSearch',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.setState({ detailsTab: 'KnowledgeSearch' });
                            this.setState({ isSummaryLoad: false });
                          }}
                          to="#"
                          title="Knowledge Search"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                              />
                            </svg>
                          </i>
                          {detailsTab === 'KnowledgeSearch' && (
                            <IntlMessages id="content.knowledgesearch" />
                          )}
                        </NavLink>
                      </NavItem>
                      {/* <NavItem className="text-center">
                        <NavLink
                          style={{
                            background: `${detailsTab === 'EmailAssist' ? 'white' : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: detailsTab === 'EmailAssist',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.setState({ detailsTab: 'EmailAssist' });
                          }}
                          to="#"
                          title="EmailAssist"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            class="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
                            />
                          </svg>
                          {detailsTab === 'EmailAssist' && ' Email Assist'}
                        </NavLink>
                      </NavItem> */}
                      {selectedChat !== undefined && selectedChat !== null && (
                        <NavItem className="text-center  nav-width">
                          <NavLink
                            style={{
                              background: `${detailsTab === 'CallInfo' ? 'white' : 'none'
                                }`,
                              cursor: 'pointer',
                            }}
                            className={classnames({
                              active: detailsTab === 'CallInfo',
                              'nav-link': true,
                            })}
                            onClick={() => {
                              this.setState({ detailsTab: 'CallInfo' });
                              this.setState({ isSummaryLoad: false });
                            }}
                            to="#"
                          >
                            <i
                              className="iconsminds-profile"
                              style={{
                                fontSize: '17px',
                                color: 'var(--theme-color-1)',
                              }}
                            >
                              {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                      />
                    </svg> */}
                            </i>

                            {detailsTab === 'CallInfo' &&
                              (selectedChat !== undefined &&
                                selectedChat !== null &&
                                selectedChat.channel === 'PhoneSuite' ? (
                                <IntlMessages id="content.callinfo" />
                              ) : (
                                <IntlMessages id="content.visitorinfo" />
                              ))}
                          </NavLink>
                        </NavItem>
                      )}
                      {selectedChat !== undefined && selectedChat !== null && (
                        <NavItem className="text-center  nav-width">
                          <NavLink
                            style={{
                              background: `${detailsTab === 'AiInsight' ? 'white' : 'none'
                                }`,
                              cursor: 'pointer',
                            }}
                            className={classnames({
                              active: detailsTab === 'AiInsight',
                              'nav-link': true,
                            })}
                            onClick={() => {
                              this.setState({ detailsTab: 'AiInsight' });
                            }}
                            to="#"
                            title="AI Insights"
                          >
                            {' '}
                            <i className="svg-class">
                              <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                                viewBox="0 0 512.000000 512.000000"
                                preserveAspectRatio="xMidYMid meet"
                                className="size-6"
                              >
                                <g
                                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                  stroke="none"
                                >
                                  <path d="M2505 5096 c-33 -33 -37 -68 -33 -266 l3 -172 28 -24 c16 -13 41 -24 57 -24 16 0 41 11 57 24 l28 24 3 172 c2 95 1 188 -3 207 -9 47 -46 83 -85 83 -19 0 -40 -9 -55 -24z" />
                                  <path d="M1539 4845 c-29 -16 -52 -66 -42 -93 16 -47 190 -336 210 -349 30 -20 87 -9 108 20 28 40 18 75 -67 226 -46 80 -94 158 -108 173 -31 34 -67 42 -101 23z" />
                                  <path d="M3486 4828 c-46 -48 -196 -318 -196 -354 0 -16 7 -39 15 -51 21 -29 78 -40 108 -20 20 13 194 302 211 350 9 28 -20 86 -49 97 -41 16 -55 12 -89 -22z" />
                                  <path d="M2450 4434 c-277 -36 -459 -102 -671 -244 -89 -60 -285 -259 -349 -354 -95 -142 -171 -326 -212 -511 -8 -39 -13 -129 -13 -255 1 -177 3 -205 27 -300 73 -289 176 -470 391 -684 71 -70 136 -145 145 -165 11 -26 18 -83 22 -201 5 -142 9 -171 28 -206 25 -49 72 -98 113 -120 26 -13 29 -20 29 -64 0 -71 18 -144 45 -185 l24 -35 -24 -35 c-29 -43 -48 -125 -39 -174 3 -20 19 -59 34 -86 27 -50 28 -51 9 -74 -11 -13 -26 -48 -35 -79 -39 -135 46 -278 186 -312 85 -20 140 9 140 75 0 41 -36 85 -70 85 -36 0 -77 28 -88 60 -13 35 -8 56 21 87 20 22 26 23 207 23 194 0 243 8 260 40 18 34 12 85 -13 108 -22 21 -32 22 -209 22 -112 0 -198 4 -218 11 -39 14 -65 65 -51 101 20 54 31 56 248 60 197 3 202 3 227 27 34 32 36 88 4 119 -22 19 -36 21 -223 24 -223 3 -238 7 -256 68 -6 19 -9 51 -7 70 l3 35 230 3 c219 2 230 3 252 24 33 31 31 87 -3 119 l-26 24 -288 3 -288 3 -23 25 c-23 24 -24 34 -29 192 -6 161 -7 169 -38 235 -26 56 -53 90 -160 195 -143 141 -201 217 -266 349 -94 190 -131 364 -123 583 8 224 60 394 179 588 66 108 232 278 342 352 141 94 316 163 479 190 93 15 303 12 396 -5 374 -71 691 -313 864 -660 131 -263 154 -597 61 -882 -64 -198 -152 -332 -331 -510 -111 -110 -139 -143 -165 -200 -31 -66 -32 -74 -38 -235 -5 -159 -6 -168 -29 -192 -24 -26 -27 -26 -168 -26 -163 0 -206 -11 -224 -57 -11 -31 -7 -58 15 -88 12 -17 29 -21 123 -25 l108 -5 3 -35 c5 -48 -13 -102 -39 -119 -12 -7 -58 -16 -102 -20 -83 -7 -101 -18 -113 -66 -16 -63 43 -105 144 -105 48 0 62 -4 79 -23 30 -33 34 -54 19 -91 -17 -40 -55 -56 -136 -56 -43 0 -61 -5 -78 -20 -29 -27 -37 -63 -20 -96 18 -40 52 -54 129 -54 55 0 69 -4 86 -22 29 -32 34 -53 21 -88 -19 -55 -42 -60 -301 -60 l-234 0 -27 -26 c-33 -34 -34 -74 -2 -111 l24 -28 181 -5 182 -5 -30 -47 c-87 -137 -265 -153 -399 -37 -62 54 -152 24 -152 -51 0 -72 144 -172 279 -193 209 -32 416 104 470 310 9 31 18 43 40 51 69 24 130 108 146 199 8 49 -14 134 -44 172 -19 25 -19 25 9 75 15 28 31 67 34 87 9 49 -10 131 -39 174 l-24 35 24 35 c27 41 45 114 45 185 0 44 3 51 29 64 41 22 88 71 113 120 19 35 23 64 28 206 4 119 10 175 22 202 9 20 73 93 145 165 240 238 352 449 409 768 17 97 19 303 4 405 -89 584 -548 1055 -1125 1155 -94 16 -275 26 -335 19z" />
                                  <path d="M823 4130 c-47 -19 -59 -96 -20 -133 42 -42 323 -197 356 -197 69 0 105 82 59 134 -28 31 -311 196 -347 201 -14 3 -36 0 -48 -5z" />
                                  <path d="M4230 4133 c-47 -19 -309 -178 -329 -200 -45 -51 -7 -133 61 -133 32 0 315 156 356 197 22 22 29 64 16 98 -12 30 -69 51 -104 38z" />
                                  <path d="M2008 3386 c-70 -29 -113 -64 -154 -125 -43 -64 -58 -114 -58 -198 1 -130 77 -243 203 -301 48 -22 73 -27 178 -30 l122 -4 3 -483 3 -483 24 -26 c30 -32 78 -34 115 -5 l26 20 0 490 0 489 90 0 90 0 0 -489 0 -490 26 -20 c37 -29 85 -27 115 5 l24 26 3 483 3 483 122 4 c105 3 130 8 178 30 78 36 133 89 171 165 26 53 31 76 32 136 0 84 -15 134 -58 199 -113 169 -353 199 -505 62 -29 -26 -62 -69 -78 -102 -25 -51 -29 -70 -33 -187 l-5 -130 -85 0 -85 0 -5 130 c-4 117 -8 136 -33 187 -77 157 -268 230 -429 164z m219 -172 c60 -45 68 -66 71 -195 l4 -119 -99 0 c-74 0 -108 5 -139 19 -127 58 -133 225 -10 302 41 26 134 22 173 -7z m839 7 c123 -75 117 -244 -10 -302 -31 -14 -65 -19 -138 -19 l-98 0 0 104 c0 111 8 147 43 185 48 52 145 67 203 32z" />
                                  <path d="M564 3146 c-40 -18 -59 -62 -44 -101 20 -52 29 -54 248 -55 202 0 203 0 227 25 44 43 29 112 -29 135 -41 15 -364 12 -402 -4z" />
                                  <path d="M4151 3149 c-55 -22 -69 -92 -26 -134 24 -25 25 -25 227 -25 221 1 229 3 249 58 14 41 -9 86 -52 101 -39 14 -364 14 -398 0z" />
                                  <path d="M1115 2334 c-97 -51 -280 -160 -305 -181 -60 -50 -27 -143 49 -143 36 0 332 164 364 202 24 28 21 72 -5 102 -30 33 -66 40 -103 20z" />
                                  <path d="M3934 2340 c-50 -20 -70 -89 -36 -128 9 -12 88 -62 174 -112 172 -99 207 -109 246 -67 30 32 29 87 -1 115 -29 27 -311 190 -340 197 -12 2 -32 0 -43 -5z" />
                                </g>
                              </svg>
                            </i>
                            {detailsTab === 'AiInsight' && ' AI Insights'}
                          </NavLink>
                        </NavItem>
                      )}
                      {this.props.integrations !== undefined &&
                        this.props.integrations.filter(
                          (f) =>
                            f.channel === 'Amadues' &&
                            f.properties.includes(this.props.propertyId) &&
                            f.disabled === false
                        ).length > 0 && (
                          <NavItem className="text-center">
                            <NavLink
                              style={{
                                background: `${detailsTab === 'Availability & Rates'
                                  ? 'white'
                                  : 'none'
                                  }`,
                                cursor: 'pointer',
                              }}
                              className={classnames({
                                active: detailsTab === 'Availability & Rates',
                                'nav-link': true,
                              })}
                              onClick={() => {
                                this.setState({
                                  detailsTab: 'Availability & Rates',
                                });
                                this.setState({ isSummaryLoad: false });
                              }}
                              to="#"
                              title="Availability & Rates"
                            >
                              <i className="svg-class">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth="1"
                                  stroke="currentColor"
                                  class="size-6"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
                                  />
                                </svg>
                              </i>
                              {detailsTab === 'Availability & Rates' && (
                                <IntlMessages id="content.availabilityrates" />
                              )}
                            </NavLink>
                          </NavItem>
                        )}
                    </Nav>
                  </CardHeader>
                  <TabContent activeTab={detailsTab} className="">
                    <TabPane tabId="CallInfo" className="chat-app-tab-pane">
                      {selectedChat !== undefined &&
                        selectedChat !== null &&
                        selectedChat.visitor != null && (
                          <Visitor
                            item={selectedChat}
                            hideButtons={true}
                            //twilioMakingConnection={this.twilioMakingConnection}
                            StopFacebookChat={this.StopFacebookChat}
                            ResumeFacebookChat={this.ResumeFacebookChat}
                            toggle={this.toggle}
                            recordingurl={this.state.recordingurl}
                            transcript={this.state.transcript}
                            quickReplyTemplates={[]}
                            propertyId={this.props.propertyId}
                            loadQuickTemmplates={this.loadQuickTemmplates}
                            //statustoggle={this.statustoggle}
                            handleMaskClick={this.handleMaskClick}
                            isMasked={this.state.isMasked}
                            clickedLinks={
                              selectedChat.clickedLinks !== undefined
                                ? selectedChat.clickedLinks
                                : undefined
                            }
                            handleStatusSubmit={this.handleStatusSubmit}
                          />
                        )}
                    </TabPane>
                    <TabPane tabId="AiInsight" className="chat-app-tab-pane ">
                      <div className="scroll cardHeight visitor  conversation-height archive-card card-box">
                        {selectedChat !== undefined &&
                          selectedChat !== null && (
                            <Fragment>
                              <div className="icon-row-item mb-4">
                                <Button
                                  size="xs"
                                  outline
                                  color="primary"
                                  className="ml-1 btn-round mt-3 btn-insights"
                                  onClick={() => this.handleGenerateSummary()}
                                >
                                  {selectedChat &&
                                    selectedChat.conversationSummary === null ? (
                                    <Fragment>
                                      <FontAwesomeIcon
                                        className="plusicon"
                                        icon={faPlus}
                                      ></FontAwesomeIcon>{' '}
                                      Generate Insights
                                    </Fragment>
                                  ) : (
                                    <Fragment>
                                      <svg
                                        version="1.0"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="24"
                                        className="refresh"
                                        viewBox="0 0 512.000000 512.000000"
                                        preserveAspectRatio="xMidYMid meet"
                                        fill="none"
                                      >
                                        <g
                                          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                          stroke="none"
                                        >
                                          <path d="M2390 5114 c-227 -19 -424 -53 -589 -103 -549 -165 -1035 -530 -1366 -1026 -145 -217 -277 -510 -350 -780 -31 -115 -28 -152 16 -189 l31 -26 368 0 c368 0 369 0 394 23 14 12 52 87 90 174 88 205 124 274 191 368 125 173 265 308 441 425 319 211 685 308 1060 280 255 -19 408 -59 619 -160 153 -74 271 -153 420 -282 5 -5 -93 -111 -242 -261 -260 -261 -273 -278 -273 -357 0 -78 53 -159 125 -191 38 -17 87 -19 835 -19 748 0 797 2 835 19 51 23 101 79 114 128 7 25 11 304 11 818 0 878 4 823 -77 896 -66 59 -157 69 -238 26 -16 -9 -129 -115 -250 -236 -121 -122 -223 -221 -228 -221 -4 0 -52 38 -107 84 -379 319 -815 515 -1310 591 -100 15 -425 27 -520 19z" />
                                          <path d="M125 2111 c-51 -23 -101 -79 -114 -128 -7 -25 -11 -304 -11 -816 0 -864 -4 -816 68 -890 64 -66 157 -80 242 -36 19 10 134 117 255 238 121 122 225 221 231 221 6 0 21 -12 35 -26 77 -83 345 -276 509 -366 222 -122 527 -228 790 -273 366 -62 797 -36 1165 71 541 158 1053 545 1375 1039 137 210 265 501 340 772 29 104 30 114 16 146 -28 68 -21 67 -418 67 -356 0 -357 0 -382 -22 -14 -13 -52 -88 -90 -175 -88 -205 -124 -274 -191 -368 -81 -113 -157 -196 -255 -283 -451 -398 -1074 -528 -1645 -345 -202 64 -409 179 -575 317 l-71 59 250 251 c258 260 271 277 271 356 0 78 -53 159 -125 191 -38 17 -87 19 -835 19 -748 0 -797 -2 -835 -19z" />
                                        </g>
                                      </svg>{' '}
                                      <IntlMessages id="content.regenerateinsights" />
                                    </Fragment>
                                  )}
                                </Button>
                              </div>
                              {this.state.isSummaryLoad ? (
                                <div
                                  className="loading"
                                  style={{ position: 'absolute', top: '150px' }}
                                />
                              ) : (
                                selectedChat &&
                                selectedChat.conversationSummary !== null && (
                                  <ConversationSummary
                                    conversationSummary={
                                      this.isValidJSON(
                                        selectedChat.conversationSummary
                                          ?.assistantResponse
                                      )
                                        ? JSON.parse(
                                          selectedChat.conversationSummary
                                            ?.assistantResponse
                                        )
                                        : selectedChat.conversationSummary
                                          ?.assistantResponse
                                    }
                                    isLoading={this.state.isSummaryLoad}
                                    tickettoggle={this.toggle}
                                    handleStatusSubmit={this.handleStatusSubmit}
                                    selectedChat={selectedChat}
                                  ></ConversationSummary>
                                )
                              )}
                            </Fragment>
                          )}
                      </div>
                    </TabPane>
                    <TabPane tabId="Conversation" className="chat-app-tab-pane">
                      {selectedChat !== undefined &&
                        selectedChat !== null &&
                        selectedChat !== '' ? (
                        <Card
                          className="cardHeightTickets con-ticket-height"
                          style={{
                            overflow: 'scroll',
                            backgroundColor: selectedChat
                              ? `${selectedChat.colours?.botBackground}`
                              : '#fff',
                            scrollbarColor: `darkgrey ${selectedChat.colours?.botBackground}`,
                          }}
                        >
                          <CardBody>
                            <div className="scroll  ">
                              {selectedChat && (
                                <div>
                                  {selectedChat.messages != null &&
                                    selectedChat.messages.length > 0 &&
                                    selectedChat.messages.map((item, index) => {
                                      // const sender = allContacts.find(x => x.id === item.sender);
                                      return (
                                        <ChatMessage
                                          key={index}
                                          sender={item.sender}
                                          item={item}
                                          avatar={selectedChat.avatar}
                                          colors={selectedChat.colours}
                                        />
                                      );
                                    })}
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ) : (
                        <Card className="cardHeightTickets text-center">
                          {/* <img
                            src={ticket_no_conversation}
                            alt="No Active Conversations"
                            style={{
                              width: '60%',
                              marginTop: '8rem',
                              marginLeft: '6rem',
                            }}
                          /> */}
                        </Card>
                      )}
                    </TabPane>
                    <TabPane
                      tabId="KnowledgeSearch"
                      className="chat-app-tab-pane"
                    >
                      <KnowledgeSearch></KnowledgeSearch>
                    </TabPane>
                    <TabPane
                      tabId="EmailAssist"
                      className="chat-app-tab-pane"
                    ></TabPane>
                    {this.props.integrations !== undefined &&
                      this.props.integrations.filter(
                        (f) =>
                          f.channel === 'Amadues' &&
                          f.properties.includes(this.props.propertyId) &&
                          f.disabled === false
                      ).length > 0 && (
                        <TabPane
                          tabId="Availability & Rates"
                          className="chat-app-tab-pane"
                        >
                          <AvailabilityAndRates
                            amadues={
                              this.props.integrations.filter(
                                (f) =>
                                  f.channel === 'Amadues' &&
                                  f.properties.includes(
                                    this.props.propertyId
                                  ) &&
                                  f.disabled === false
                              )[0]
                            }
                          ></AvailabilityAndRates>
                        </TabPane>
                      )}
                  </TabContent>
                </Colxx>
              </Row>
            </Colxx>
            <Colxx xxs="1" lg="2">
              <div className="app-menu ticket-filter">
                <Row className="ml-1">
                  <Colxx xxs="12" className="mt-4">
                    <h6 className="ml-px">
                      {' '}
                      {/* <FontAwesomeIcon
                        icon={faFilter}
                        style={{ color: '#ef4a81' }}
                      ></FontAwesomeIcon>{' '} */}
                      <i className="iconsminds-filter-2 mr-2" />
                      Status
                    </h6>
                  </Colxx>
                  <Colxx xxs="10" className="text-left">
                    <CustomInput
                      type="checkbox"
                      id={'All Tickets'}
                      value={'-1'}
                      label={'All Tickets'}
                      checked={
                        this.state.statusFilter.filter(
                          (m) => m.checked === true
                        ).length === 0
                      }
                      onClick={(e) => this.handleCheckedStatusFilter(e)}
                    />
                  </Colxx>
                  <Colxx xxs="2" className="text-center">
                    {this.state.data === undefined ? 0 : this.state.data.length}
                  </Colxx>
                  {this.state.statusFilter.map((item, index) => (
                    <Fragment>
                      <Colxx xxs="10" className="text-left">
                        <CustomInput
                          type="checkbox"
                          id={item.value}
                          value={item.value}
                          label={item.label}
                          checked={item.checked}
                          onClick={(e) => this.handleCheckedStatusFilter(e)}
                        />
                      </Colxx>
                      <Colxx xxs="2" className="text-center">
                        {this.state.data === undefined
                          ? 0
                          : this.state.data.filter(
                            (l) =>
                              l.status.toLowerCase() ===
                              item.value.toLowerCase()
                          ).length}
                      </Colxx>
                    </Fragment>
                  ))}
                </Row>
                <Row className="ml-1">
                  <Colxx xxs="12" className=" mt-4">
                    <h6 className="ml-px">
                      {' '}
                      {/* <FontAwesomeIcon
                        icon={faFolder}
                        style={{ color: '#ef4a81' }}
                        className="mr-2"
                      ></FontAwesomeIcon> */}
                      <i className="iconsminds-folders mr-2" />
                      Categories
                    </h6>
                  </Colxx>
                  <Colxx xxs="10" className="text-left">
                    <CustomInput
                      type="checkbox"
                      id={'AllCategory'}
                      name={'AllCategory'}
                      label={'All Categories'}
                      value={'-1'}
                      checked={
                        this.state.categoryFilter.filter(
                          (x) => x.checked === true
                        ).length === 0
                      }
                      onClick={(e) => this.handleCheckedFilter(e)}
                    />
                  </Colxx>
                  <Colxx xxs="2" className="text-center">
                    {this.state.data === undefined ? 0 : this.state.data.length}
                  </Colxx>
                  {this.state.categoryFilter.length > 0 &&
                    this.state.categoryFilter.map((item, i) => (
                      <Fragment>
                        <Colxx xxs="10" className="text-left">
                          <CustomInput
                            key={i}
                            type="checkbox"
                            id={item.value}
                            value={item.value}
                            label={item.label}
                            checked={item.checked}
                            onClick={(e) => this.handleCheckedFilter(e)}
                          />
                        </Colxx>
                        <Colxx xxs="2" className="text-center">
                          {this.state.data === undefined
                            ? 0
                            : this.state.data.filter((l) =>
                              l.tags.includes(item.value)
                            ).length}
                        </Colxx>
                      </Fragment>
                    ))}
                </Row>
              </div>
            </Colxx>
          </Row>
          <Modal isOpen={isNewTicket} toggle={this.toggleNewTicket} size="lg">
            <ModalHeader toggle={this.toggleNewTicket}>
              Create Ticket
            </ModalHeader>
            <ModalBody>
              <Row>
                <Colxx xxs="12">
                  <Row className="mb-2">
                    <Colxx xxs="3">
                      <label>Ticket Category</label>
                    </Colxx>
                    <Colxx xxs="9">
                      <Select
                        className="react-select"
                        classNamePrefix="react-select"
                        name="category"
                        onChange={this.handleChangeMultiCategory}
                        options={this.state.categoryList}
                        value={this.state.ticketSelectedCategory}
                      />
                    </Colxx>
                  </Row>
                  {this.state.formList.length > 0 ? (
                    <Fragment>
                      {this.state.formList.length > 1 && (
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Forms</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input
                              type="select"
                              name="ticketFormId"
                              value={this.state.ticketFormId}
                              onChange={(e) => this.handleFormChange(e)}
                            >
                              <option value="">Select</option>
                              {this.state.formList.map((item, i) => (
                                <option value={item.id} key={i}>
                                  {item.name}
                                </option>
                              ))}
                            </Input>
                          </Colxx>
                        </Row>
                      )}
                      {this.state.ticketFormId !== null &&
                        this.state.ticketFormId !== '' &&
                        this.state.formWebviewUrl !== null &&
                        this.state.formWebviewUrl !== '' && (
                          <Row>
                            <Colxx xxs="12">
                              <iframe
                                src={this.state.formWebviewUrl}
                                border="0"
                                width={'100%'}
                                height={'550px'}
                              ></iframe>
                            </Colxx>
                          </Row>
                        )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>Title</label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input
                            name="ticketTitle"
                            value={this.state.ticketTitle}
                            onChange={this.handleInputChange}
                            type="text"
                            placeHolder="Title"
                          />
                        </Colxx>
                      </Row>
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>Notes</label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input
                            name="ticketComments"
                            value={this.state.ticketComments}
                            onChange={this.handleInputChange}
                            type="textarea"
                            placeHolder="Notes"
                          />
                        </Colxx>
                      </Row>
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="pages.status" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Select
                            className="react-select"
                            classNamePrefix="react-select"
                            name="status"
                            value={this.state.ticketSelectedStatus}
                            onChange={this.handleStatus}
                            options={StatusOptions}
                          />
                        </Colxx>
                      </Row>
                      {this.state.ticketStatus === 'Pending' && (
                        <Row className="mb-2">
                          <Colxx xxs="3">
                            <label>Assign To</label>
                          </Colxx>
                          <Colxx xxs="9">
                            <Input
                              name="ticketAssignTo"
                              onChange={this.handleInputChange}
                              type="text"
                              value={this.state.ticketAssignTo}
                              placeholdertext="Enter Email"
                            />
                          </Colxx>
                        </Row>
                      )}
                      <Row>
                        <Colxx xxs="3">
                          <Button
                            color="primary"
                            className="mb-2"
                            onClick={this.handleCreateTicketSubmit}
                          >
                            <IntlMessages id="forms.submit" />
                          </Button>
                        </Colxx>
                      </Row>
                    </Fragment>
                  )}
                </Colxx>
              </Row>
            </ModalBody>
          </Modal>
          {this.state.isExportCsv &&
            this.state.propertyData &&
            this.state.propertyData.contacts && (
              <TicketsContactsForm
                images={this.state.propertyData.contacts}
                id={this.props.propertyId}
                visible={this.state.isExportCsv}
                toggle={() => this.setState({ isExportCsv: false })}
                isMissingURL={this.state.isMissingURL}
                csvReport={this.state.csvReport}
                csvTicket={this.state.csvTicket}
              />
            )}
          <Row>
            <Colxx xxs="12">
              <Modal isOpen={modal} toggle={this.toggle} size="lg">
                <ModalHeader toggle={this.toggle}>
                  <IntlMessages id="Ticket Details" />
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Colxx xxs="12">
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="Notes" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <ReactQuill
                            theme="snow"
                            onChange={(content, delta, source) =>
                              this.handleNotes(source, content)
                            }
                            modules={quillModules}
                            formats={quillFormats}
                            name="ticketNotes"
                          />
                        </Colxx>
                      </Row>
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="pages.status" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Select
                            className="react-select"
                            classNamePrefix="react-select"
                            name="preTicketStatus"
                            value={preTicketStatus || preFillStatus}
                            onChange={this.handleChangeSelect}
                            options={
                              this.state.isMissingURL !== 'missingresponse'
                                ? StatusOptions
                                : [...StatusOptions, ...StatusOptionMissed]
                            }
                          />
                        </Colxx>
                      </Row>
                      {preTicketStatus !== null &&
                        preTicketStatus.value === 'Pending' && (
                          <Row className="mb-2">
                            <Colxx xxs="3">
                              <label>Assignee</label>
                            </Colxx>
                            <Colxx xxs="9">
                              <Input
                                name="assignee"
                                onChange={this.handleInputChange}
                                type="text"
                                placeholder="Enter assinee email"
                              />
                            </Colxx>
                          </Row>
                        )}
                      <Row>
                        <Colxx xxs="3">
                          <Button
                            color="primary"
                            className="mb-2"
                            onClick={this.handleTicketSubmit}
                          >
                            <IntlMessages id="forms.submit" />
                          </Button>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </div>
        <Validation
          Open={this.state.Open}
          messages={this.state.msg}
          toggle={() => {
            this.setState({ Open: false });
          }}
        ></Validation>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ chatListApp, usersListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    getPropertyList,
    getChat,
  })(TicketsPage)
);
